/**
 * OVERRIDE SummaryView.jsx
 */

import SummaryView from '../../../../components/View/SummaryView';

export default SummaryView;